import {ShippingType} from "@/types/enums";

export type CheckoutFormData = {
    creditCard: CreditCard,
}

export type Address = {
    sex?: Sex,
    name: string,
    surname: string,
    addition?: string,
    hasCompany?: boolean,
    company?: string,
    vatNumber?: string,
    street: string,
    zipcode: string,
    city: string,
    country: number,
    // country: Country,
    phone?: string,
    email?: string,
}

type AdditionalOptions = {
    assembly: boolean,
    hasVoucher: boolean,
    voucher: string,
    trustedShops: boolean,
    hasSpecialWish: boolean,
    specialWish: string,
}

export enum Country {
    Austria = 'oesterreich',
    Belgium = 'belgium',
    Denmark = 'denmark',
    France = 'france',
    Germany = 'deutschland',
    GreatBritain = 'großbritannien',
    Italy = 'italy',
    Liechtenstein = 'liechtenstein',
    Luxembourg = 'luxemburg',
    Netherlands = 'netherlands',
    Norway = 'norway',
    Poland = 'poland',
    Portugal = 'portugal',
    Spain = 'spain',
    Sweden = 'sweden',
    Switzerland = 'schweiz'
}

export enum Sex {
    Male = 'm',
    Female = 'f'
}

type Invoice = {
    birthDate: {
        day: string|null,
        month: string|null,
        year: string|null
    }
}

export enum PaymentOptions {
    Empty = 0,
    Transfer = 'ueberweisung',
    PayPal = 'paypal',
    PayPalInstallments = 'paypal-installments',
    RatePayDebit = 'ratepay-debit',
    RatePayInstallment = 'ratepay-installment',
    RatePayInvoice = 'ratepay-invoice',
    Invoice = 'pw-invoice',
    CreditCard = 'credit_card',
    AmazonPay = 'amazon-pay',
    Pledg = 'pledg',
    PartialPayment = 'partial-payment',
}

export type CreditCard = {
    number: string,
    expiration: {
        month: string,
        year: string,
    },
    name: string,
    cvc: string
}

export default CheckoutFormData;

